import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { Appointment, IAppointment, IDataSourceBackendParam, TELECONSULTATION_PERIOD_KEY } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { AppointmentService } from "src/app/providers/appointment.service";

export type TeleconsultationDataSourceBackendParam = IDataSourceBackendParam & { appointmentPeriod?: TELECONSULTATION_PERIOD_KEY };

export class TeleconsultationDataSource extends MatTableDataSourceBackendExtended<Appointment> {
  public rawData$ = this.dataSubject.asObservable();

  constructor(private appointmentService: AppointmentService) {
    super();
  }

  public data(params: TeleconsultationDataSourceBackendParam): Observable<Appointment[]> {
    return this.appointmentService.getTeleconsultations(params).pipe(
      map((values) => {
        return values.map((v) => {
          const app: IAppointment = v.teleconsultation;
          app.patientInfo = v.patientInfo;
          return new Appointment(app);
        });
      })
    );
  }
  protected dataCount(_param: TeleconsultationDataSourceBackendParam): Observable<number> {
    /*
      Use this, the day we decide to make the page implements AbstractBackendTablePage
      return this.appointmentService
        .getTeleconsultationsCount(param.filters, param.services, param.organization).pipe(map((response) => response.count));
    */
    return of(0);
  }
}
